import { defineComponent as _defineComponent } from 'vue'
import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import UserMenu from './UserMenu.vue';
import { isDescendant } from 'ah-common-lib/src/helpers/dom';
import { BModal } from 'bootstrap-vue';
import { useAuthStore } from 'bd-common/src/store/authStore';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserIconMenu',
  setup(__props) {

const show = ref(false);
const userMenu = ref<HTMLElement>();
const deleteModal = ref<BModal>();

const toggleShow = () => {
  // Run in next tick to avoid click event propagation issues
  setTimeout(() => {
    show.value = !show.value;
  }, 0);
};

let clickListener: (event: MouseEvent) => void;

onMounted(() => {
  clickListener = (event) => {
    if (show.value && (!userMenu.value || !isDescendant(userMenu.value, event.target as Element, true))) {
      show.value = false;
    }
  };

  window.addEventListener('click', clickListener);
});

onBeforeUnmount(() => {
  window.removeEventListener('click', clickListener);
});

const authStore = useAuthStore();

const logout = () => {
  if (deleteModal.value) {
    deleteModal.value.show?.();
    const onceOk = () => {
      authStore.logout();
      show.value = false;
      deleteModal.value?.$off('ok', onceOk);
    };
    deleteModal.value?.$on('ok', onceOk);
  }
};

const user = ref(authStore.loggedInIdentity);

const initials = computed(() => ((user.value?.firstName || ' ')[0] + (user.value?.lastName || ' ')[0]).toUpperCase());

watch(
  () => authStore.loggedInIdentity,
  (newUser) => {
    user.value = newUser;
    show.value = false;
  }
);

return { __sfc: true,show, userMenu, deleteModal, toggleShow, clickListener, authStore, logout, user, initials, UserMenu, BModal, MaterialIcon }
}

})